import { ApiClient } from './ApiClient';
import { ApiConnector } from '_helpers';
import apiConfig from '../config/apiConfig.default';
import subscribeToOnlineEvents from './OnlineEvents';
import { OnlineMethods } from './OnlineMethods';

const apiConnector = new ApiConnector(ApiClient, apiConfig, subscribeToOnlineEvents, OnlineMethods);

export default apiConnector;
